import { hashRoomLayoutGenerators } from "./roomLayout";
import roomLayoutBathroom from "./roomLayoutBathroom";
import roomLayoutBedroom from "./roomLayoutBedroom";
import roomLayoutCloset from "./roomLayoutCloset";
import roomLayoutGarage from "./roomLayoutGarage";
import roomLayoutKitchen from "./roomLayoutKitchen";
import roomLayoutLiving from "./roomLayoutLiving";
import roomLayoutUtility from "./roomLayoutUtility";

export const interiorRoomLayouts = hashRoomLayoutGenerators(
  ...roomLayoutUtility,
  ...roomLayoutBathroom,
  ...roomLayoutBedroom,
  ...roomLayoutLiving,
  ...roomLayoutGarage,
  ...roomLayoutCloset,
  ...roomLayoutKitchen,
);

export const exteriorRoomLayouts = hashRoomLayoutGenerators();
